module.exports = __webpack_public_path__ + "static/softball3-495eba8140100f484bd078a2712b0e46.jpg";